// extracted by mini-css-extract-plugin
export default {"wrapperMain":"ErrorMod_wrapperMain__xVpYr","titolo":"ErrorMod_titolo__Nq+Ti","Btn":"ErrorMod_Btn__BivjD","img":"ErrorMod_img__-L07d"};